var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoanimation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    className: "anim-logo",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10_17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.88 21.21L23.26 23.58C21.6734 25.1626 19.7211 26.3296 17.5758 26.9776C15.4306 27.6257 13.1587 27.7348 10.9612 27.2953C8.76375 26.8558 6.70859 25.8812 4.97763 24.4579C3.24667 23.0346 1.89335 21.2065 1.0375 19.1354C0.181656 17.0643 -0.150341 14.8141 0.0709517 12.5841C0.292244 10.354 1.05999 8.21296 2.30618 6.35043C3.55238 4.48791 5.23856 2.96139 7.21548 1.90603C9.19241 0.850679 11.3991 0.299049 13.64 0.299989V3.64999C12.2582 3.65572 10.8919 3.94134 9.6235 4.4896C8.35511 5.03786 7.21095 5.83741 6.26004 6.83999C4.82234 8.30883 3.87851 10.1895 3.56003 12.22C3.19582 14.3599 3.52043 16.5603 4.48703 18.5039C5.45363 20.4476 7.0123 22.0342 8.93851 23.0351C10.8647 24.036 13.059 24.3996 15.205 24.0734C17.3511 23.7472 19.3382 22.748 20.88 21.22",
    fill: "#131313",
    className: "semi-circle"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "3s",
    repeatCount: "indefinite",
    values: ".2; .6; .8; .6; 0.2",
    keyTimes: "0; 0.25; 0.5; 0.75; 1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    from: "rgb(0,0,255)",
    to: "rgb(128,0,0)",
    dur: "3s",
    values: "#25AA4A; white; white; white; #25AA4A",
    keyTimes: "0; 0.25; 0.5; 0.75; 1",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.08 8V0.690002C19.4174 1.29767 21.5528 2.51196 23.2701 4.21L20.8601 6.61L20.51 6.37C20.51 6.53 20.51 6.65 20.51 6.77V13.91C20.5298 15.6298 19.8991 17.2935 18.7442 18.568C17.5893 19.8425 15.9956 20.6335 14.2822 20.7827C12.5688 20.9319 10.8623 20.4283 9.50449 19.3726C8.14669 18.317 7.23785 16.7873 6.96005 15.09C6.71403 13.8533 6.83471 12.5717 7.30728 11.4027C7.77986 10.2337 8.5837 9.22828 9.62003 8.51C10.6134 7.73022 11.8105 7.25325 13.0679 7.1362C14.3253 7.01914 15.5898 7.26697 16.7101 7.85L17.1001 8.05M13.64 17.37C14.313 17.3679 14.9704 17.1673 15.5299 16.7933C16.0894 16.4193 16.5261 15.8886 16.7854 15.2675C17.0446 14.6465 17.1149 13.9628 16.9874 13.302C16.8599 12.6412 16.5402 12.0327 16.0685 11.5528C15.5968 11.0728 14.994 10.7427 14.3355 10.6037C13.677 10.4648 12.9922 10.5232 12.3667 10.7716C11.7413 11.0201 11.2031 11.4475 10.8194 12.0004C10.4358 12.5534 10.2238 13.2072 10.2101 13.88C10.2007 14.3358 10.2826 14.7889 10.451 15.2126C10.6193 15.6363 10.8706 16.0221 11.1902 16.3473C11.5097 16.6724 11.8911 16.9304 12.3118 17.1061C12.7325 17.2817 13.1841 17.3714 13.64 17.37",
    fill: "#25AA4A",
    className: "music",
    id: "theMotionPath"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "3s",
    repeatCount: "indefinite",
    values: "1; .5; 0.2; .5; 1",
    keyTimes: "0; 0.25; 0.5; 0.75; 1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    dur: "3s",
    values: "#25AA4A; #25AA4A; white; #25AA4A; #25AA4A",
    keyTimes: "0; 0.25; 0.5; 0.75; 1",
    repeatCount: "indefinite"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    className: "anim-logo"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10_17"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.27,
    height: 27.29,
    fill: "white",
    transform: "translate(0 0.289978)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "rx",
    values: "0;5;0",
    dur: "10s",
    repeatCount: "indefinite"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoanimation);
export default __webpack_public_path__ + "static/media/logoanimation.3f2038b59b5bdd4431c13bcbe28edc61.svg";
export { ForwardRef as ReactComponent };